import {
  initialState,
  Actions,
  State,
  GET_CUSTOMER_CURRENT_YEAR_PERIODIC_CHECKS,
  GET_CUSTOMER_CURRENT_YEAR_PERIODIC_CHECKS_SUCCESS,
  GET_CUSTOMER_CURRENT_YEAR_PERIODIC_CHECKS_ERROR,
  RESET_GET_CUSTOMER_CURRENT_YEAR_PERIODIC_CHECKS,
} from '../../types/periodic-check/get-customer-current-year'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_CUSTOMER_CURRENT_YEAR_PERIODIC_CHECKS:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case GET_CUSTOMER_CURRENT_YEAR_PERIODIC_CHECKS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case GET_CUSTOMER_CURRENT_YEAR_PERIODIC_CHECKS_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      }
    case RESET_GET_CUSTOMER_CURRENT_YEAR_PERIODIC_CHECKS:
      return initialState
    default:
      return state
  }
}

export default reducers 